<template>
  <list-basic
    caption="詳細"
    :description="$store.state.habit.description"
    :action="action"
  />
</template>

<script>
import ListBasic from '@/lib/List/Basic/index'

export default {
  components: {
    ListBasic
  },

  methods: {
    action () {
      this.$router.push({ name: 'habit-description' })
    }
  }
}
</script>
